export default {
  title: 'Requests',
  buttons: {
    cleanAll : 'Clean all'
  },
  subtitle: {
    thisMonth: 'This month',
    previous: 'Previous'
  },
  header: {
    id: 'ID',
    date: 'Creation date',
    type: 'Type',
    status: 'Status',
    amountAuthorized: 'Amount',
    refund: 'Refund',
    coverage: 'Coverage'
  },
  dateFilter: 'Date Range',
  status: {
    all: 'All',
    pendingReview: 'Pending',
    claimed: 'Claimed',
    error: 'Error',
    paid: 'Paid',
    voided: 'Voided',
    ready: 'Pending exchange',
    partiallyClaimed: 'Partially claimed',
    qualification: 'Pending validation',
    incomplete: 'Pending information',
    rejected: 'Rejected',
    approved: 'Approved',
    requestInProgress: 'In progress',
    creditCardBalance: {
      qualification: 'Pending validation',
      incomplete: 'Pending information',
      rejected: 'Rejected',
      approved: 'Approved',
      claimed: 'Settled',
      settlementRequired: 'It is required to attach a settlement file'
    }
  },
  types: {
    pharmacy: 'Pharmacy',
    process: 'Process',
    prescriptionDrugs: 'Drugs',
    diagnosticTest: 'Diagnostic test',
    sports: 'Sports',
    wellness: 'Wellness',
    education: 'Education',
    creditCardBalance: 'Debit balance',
    occupationalHazard: 'Occupational hazard',
    prescription: 'Schedule medication',
    hospitalization: 'Hospitalization',
    therapy: 'Therapy',
    medicalFees: 'Medical fees',
    hospitalDischarge: 'Hospital discharge',
    medicalReport: 'Medical report'
  },
  graph: {
    remanentLabel: 'Remanent',
    total: 'Total',
    used: 'Used',
    available: 'Available'
  },
  filters: {
    inputSearchPlaceholder: 'Search by ID',
    filterByLabel: 'Filter by',
    stateFilterLabel: 'Status',
    dateFilterLabel: 'Date range'
  },
  filtersTitle: 'Filters',
  resultsTitle: 'results',
  itemsPerPage: 'Results / Page',
  orderBy: 'Order by',
  cleanFilter: 'Clean All',
  apply: 'Apply',
  cleanFilters: 'cleaning the filters'
}